<label class="switch">
  <input [attr.name]="formControlName" type="checkbox" [(ngModel)]="value">
  <span class="slider"></span>
</label>
